import { configureStore, Store } from "@reduxjs/toolkit"
import locationsReducer from "@hydrologiq/shared/state/slices/locationsSlice"
import sitesReducer from "@hydrologiq/shared/state/slices/sitesSlice"
import forecastReducer from "@hydrologiq/shared/state/slices/forecastSlice"
export const reducers = {
  locations: locationsReducer,
  sites: sitesReducer,
  forecast: forecastReducer,
}
const store: Store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [],
        // // Ignore these field paths in all actions
        // ignoredActionPaths: ["meta.arg", "payload.timestamp"],
        // Ignore these paths in the state
        ignoredPaths: [],
      },
    }),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
export default store
